<template>
	<div class="p-solution-weight">
    <div class="banner">
      <a class="inner" href="//wpa.qq.com/msgrd?v=3&uin=1685607977&menu=yes" target="_blank">
        <div class="title">善识一站式体重管理解决方案</div>
        <a>免费咨询</a>
      </a>
    </div>
    <div class="part">
      <img src="/image/solution/weight/1.png"/>
    </div>
    <div class="part t2">
      <div class="title">我们提供什么</div>
      <div class="tabs">
        <div class="tab" :class="{active:tab.index==i}" v-for="(o,i) in tab.list" @click="tab.index=i" :key="i">{{o}}</div>
      </div>
      <img src="/image/solution/weight/21.png" v-show="tab.index==0"/>
      <img src="/image/solution/weight/22.png" v-show="tab.index==1"/>
    </div>
    <div class="part t3">
      <img src="/image/solution/weight/3.png"/>
    </div>
    <div class="part">
      <img src="/image/solution/weight/4.png"/>
    </div>
    <div class="part t5">
      <img src="/image/solution/weight/5.png"/>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      tab: {
        index: 0,
        list: ["体重管理方案", "营养健康管理系统 (SaaS系统)"]
      }
    };
  }
};
</script>

<style lang="less">
.p-solution-weight {
  > .banner {
    width: 100%;
    height: 450px;
    display: flex;
    align-items: center;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url("/image/solution/weight/banner.png");
    > .inner {
      width: 1010px;
      display: block;
      color: #ffffff;
      margin: 0px auto;
      text-align: center;
      > .title {
        font-size: 50px;
        margin: 15px 0px;
      }
      > .desc {
        font-size: 24px;
        margin: 15px 0px;
        letter-spacing: 4px;
      }
      > a {
        font-size: 18px;
        margin: 40px 0px;
        padding: 0px 30px;
        user-select: none;
        line-height: 40px;
        border-radius: 4px;
        display: inline-block;
        border: 1px solid #40d0ad;
        background-color: #40d0ad;
      }
    }
  }
  > .part {
    padding: 80px 0px;
    &.t2 {
      height: 738px;
      color: #ffffff;
      background-size: cover;
      background-position: 50%;
      background-repeat: no-repeat;
      background-image: url("/image/solution/weight/20.png");
      > .tabs {
        display: flex;
        margin: 60px 0px;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #cccccc;
        > .tab {
          padding: 15px;
          cursor: pointer;
          font-size: 22px;
          text-align: center;
          width: calc(1010px / 2);
          border-bottom: 4px solid transparent;
          transition: 200ms;
          &:hover {
            border-color: rgba(0, 0, 0, 0.1);
          }
          &.active {
            border-color: #ffffff;
          }
        }
      }
    }
    &.t3 {
      background-color: #f5f5f5;
    }
    &.t5 {
      background-color: #f5f5f5;
    }
    > img {
      width: 1010px;
      display: block;
      margin: 0px auto;
    }
    > .title {
      font-size: 32px;
      text-align: center;
      margin-bottom: 60px;
      letter-spacing: 4px;
    }
    > .links {
      width: 1010px;
      display: flex;
      margin: 0px auto;
      align-items: center;
      justify-content: space-between;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      > .link {
        flex: 1;
        width: 0px;
        height: 356px;
        display: flex;
        line-height: 24px;
        position: relative;
        flex-direction: column;
        &:first-child {
          border-right: 1px solid #cccccc;
        }
        &:hover {
          > .img {
            height: 80px;
          }
          > .title {
            margin-top: 20px;
          }
          > .desc {
            overflow: auto;
            white-space: initial;
          }
        }
        > .img {
          height: 228px;
          background-size: cover;
          background-position: 50%;
          background-repeat: no-repeat;
          transition: 200ms;
        }
        > .title {
          margin: 20px;
          font-size: 22px;
          color: #333333;
          text-align: center;
          &::after {
            left: 50%;
            width: 35px;
            height: 3px;
            content: "";
            display: block;
            margin: 0px auto;
            position: absolute;
            text-align: center;
            border-radius: 1.5px;
            background-color: #46a8f3;
            transform: translate3d(-50%, 20px, 0);
          }
        }
        > .desc {
          flex: 1;
          height: 0px;
          margin: 20px;
          color: #666666;
          overflow: hidden;
          white-space: pre;
          text-align: center;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>